import { useTranslation } from 'react-i18next';

import { BankAccountForm } from 'src/Components/Forms/BankAccount/BankAccountForm';
import { useCreateBankAccountForm } from 'src/Hooks/Forms/useCreateBankAccountForm';
import { useCreateBankAccount } from 'src/Hooks/Mutations/useCreateBankAccount';

import { Props } from './BankAccountCreationFormWrapper.types';

const BankAccountCreationFormWrapper = ({ onCreate, onCancel }: Props) => {
  const { form } = useCreateBankAccountForm();
  const { mutate } = useCreateBankAccount({ onSuccess: onCreate });
  const { t } = useTranslation();

  return (
    <BankAccountForm
      onCancel={onCancel}
      form={form}
      onSubmit={form.onSubmit(values => mutate(values))}
      submitButtonLabel={t('bankAccounts.form.add', 'Ajouter le compte')}
    />
  );
};

export default BankAccountCreationFormWrapper;
